import type { EpisodePlan } from "@storyline/shared";
import { useState } from "react";
import { HttpError } from "@/src/common/services/api-error";
import { commitEpisodePlan, requestEpisodeProposal } from "@/src/stories/services/copilot-http.service";

const GENERIC_ERROR = "Le copilote est indisponible. Réessayez.";

export const useNewEpisode = (seriesId: string, onCreated: (episodeId: string) => void) => {
	const [plan, setPlan] = useState<EpisodePlan | null>(null);
	const [isProposing, setIsProposing] = useState(false);
	const [isCommitting, setIsCommitting] = useState(false);
	const [error, setError] = useState<string | null>(null);

	const propose = async (brief: string): Promise<void> => {
		setIsProposing(true);
		setError(null);
		try {
			setPlan(await requestEpisodeProposal(seriesId, brief));
		} catch (caught) {
			setError(caught instanceof HttpError ? caught.message : GENERIC_ERROR);
		} finally {
			setIsProposing(false);
		}
	};

	const commit = async (edited: EpisodePlan): Promise<void> => {
		setIsCommitting(true);
		setError(null);
		try {
			const episode = await commitEpisodePlan(seriesId, edited);
			setPlan(null);
			onCreated(episode.id);
		} catch (caught) {
			setError(caught instanceof HttpError ? caught.message : GENERIC_ERROR);
		} finally {
			setIsCommitting(false);
		}
	};

	const reset = (): void => {
		setPlan(null);
		setError(null);
	};

	return { plan, isProposing, isCommitting, error, propose, commit, reset };
};
